(function () {

    let togglers = document.getElementsByClassName('toggles-menu');
    let menuStates = {};
    for (let i = 0; i < togglers.length; i++) {
        togglers[i].addEventListener('click', function (e) {
            // if target has no data-target attribute, return
            if (!e.currentTarget.dataset.target) return;

            let menu = document.getElementById(e.currentTarget.dataset.target)
            if (!menu) return;

            let targetId = e.currentTarget.dataset.target;

            // if the menu is not in the menuStates object, add it
            if (!menuStates.hasOwnProperty(targetId)) {
                menuStates[targetId] = true;
            }

            console.log(menu)
            if (menuStates[targetId]) { // close the menu
                menu.classList.add(e.currentTarget.dataset.targetclass)
                menuStates[targetId] = false;
            } else { // open the menu
                menu.classList.remove(e.currentTarget.dataset.targetclass)
                menuStates[targetId] = true;
            }
        })
    }

    let filterToggles = document.getElementsByClassName('filter-menu-toggle');
    let toggleState = true;
    for (let i = 0; i < filterToggles.length; i++) {
        filterToggles[i].addEventListener('click', function (e) {
            e.stopPropagation();
            console.log(toggleState)
            let filterBg = document.getElementById('filter-bg');
            let filter = document.getElementById('filter-menu');
            let wrapper = document.getElementById('filter-wrapper');

            if (toggleState) {
                wrapper.classList.add('filter-wrapper-open');
                filterBg.classList.add('filter-bg-open');
                filter.classList.add('filter-menu-open');
                wrapper.classList.remove('filter-wrapper-closed');
                filterBg.classList.remove('filter-bg-closed');
                filter.classList.remove('filter-menu-closed');
                toggleState = false;
            } else {
                wrapper.classList.add('filter-wrapper-closed');
                filterBg.classList.add('filter-bg-closed');
                filter.classList.add('filter-menu-closed');
                wrapper.classList.remove('filter-wrapper-open');
                filterBg.classList.remove('filter-bg-open');
                filter.classList.remove('filter-menu-open');
                toggleState = true;
            }
        })
    }

    // get all inputs with name tags[] and add event listener
    let tags = document.getElementsByName('tags[]');
    for (let i = 0; i < tags.length; i++) {
        tags[i].addEventListener('change', function (e) {
            // refresh the page with the new tag in the query string
            let url = new URL(window.location.href);
            let checkedTags = [];
            for (let i = 0; i < tags.length; i++) {
                if (tags[i].checked) {
                    checkedTags.push(tags[i].value);
                }
            }
            url.searchParams.set('tags', checkedTags.join(','));
            window.location.href = url.toString();
        })
    }

    // get all inputs with name tags[] and add event listener
    let tag = document.getElementsByName('tag[]');
    for (let i = 0; i < tag.length; i++) {
        tag[i].addEventListener('change', function (e) {
            // refresh the page with the new tag in the query string
            let url = new URL(window.location.href);
            let checkedTags = [];
            for (let i = 0; i < tag.length; i++) {
                if (tag[i].checked) {
                    checkedTags.push(tag[i].value);
                }
            }
            url.searchParams.set('tags', checkedTags.join(','));
            window.location.href = url.toString();
        })
    }


})()
